import { render, staticRenderFns } from "./editBalastTable.vue?vue&type=template&id=630122d2"
import script from "./editBalastTable.vue?vue&type=script&lang=js"
export * from "./editBalastTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports